// extracted by mini-css-extract-plugin
module.exports = {"container-table":"edit-table_container-table__2Ccsn","title-month":"edit-table_title-month__23W0u"};